import React from 'react'

import clsx from 'clsx'

import InfoCircleTooltip from 'components/InfoCircleTooltip'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { hasPricingInfo } from 'helpers/pricing'

import styles from './DisplayLabel.module.scss'

/** @type {import("./types").default} */
const DisplayLabel = ({ pricing = {}, labelVariant = 'large' }) => {
  const isLabelLarge = labelVariant === 'large'
  const { sendEvent } = useEventContext()
  return (
    <div className={clsx('DisplayLabel', styles.root)}>
      <Typography className={styles.title}>{isLabelLarge ? 'Price starts from' : 'Starting from'}</Typography>
      <div
        role="button"
        onMouseEnter={() =>
          sendEvent({
            name: 'engagement_hover',
            engagementDestination: 'show_starting-price-tooltip',
            engagementDetails: 'hover_i-icon',
          })
        }
      >
        <InfoCircleTooltip
          enterTouchDelay={100}
          leaveTouchDelay={3000}
          title={
            <div className={styles.tooltip}>
              {hasPricingInfo(pricing)
                ? 'Prices can vary depending on\nyour business needs.'
                : 'Not enough information yet'}
            </div>
          }
        />
      </div>
    </div>
  )
}

export default DisplayLabel
